import FastMarquee from "react-fast-marquee";

const ITEMS = [
  "CYBER SMOKE MEDIA",
  "REAL DELIVERY",
  "SECURE & PRIVATE",
  "INFRASTRUCTURE FOR CREATORS",
  "700+ SERVICES",
  "FIVE NETWORKS. ONE CATALOG",
];

export default function Marquee() {
  return (
    <div data-testid="editorial-marquee" className="border-y border-[#1F1F1F] bg-[#050505] py-6">
      <FastMarquee speed={35} gradient={false}>
        {ITEMS.map((item) => (
          <span key={item} className="flex items-center">
            <span className="mx-8 font-mono text-sm uppercase tracking-[0.3em] text-[#8A8A8A]">
              {item}
            </span>
            <span className="h-1.5 w-1.5 bg-[#E11D2E]" />
          </span>
        ))}
      </FastMarquee>
    </div>
  );
}
